import * as TargetingRule from '@hotjar/insights-common/lib/targeting-rules';

/**
 * Service for Targeting Rule related operations.
 */
angular.module('hjApp').service('TargetingRule', () => TargetingRule);
